import { render } from "./OpinionListItem.vue?vue&type=template&id=e422079c&scoped=true"
import script from "./OpinionListItem.vue?vue&type=script&lang=js"
export * from "./OpinionListItem.vue?vue&type=script&lang=js"

import "./OpinionListItem.vue?vue&type=style&index=0&id=e422079c&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e422079c"]])

export default __exports__